import { fabric } from 'fabric';

import { CANVAS_OBJECT_TYPE_PREFIX } from '~/core/constants';
import theme from '~/theme/theme';

const {
  drawingShape: { stroke },
} = theme.light.drawingTool;
const hidePrefixes = [CANVAS_OBJECT_TYPE_PREFIX.ARROW_LABEL];
const borderPrefixes = [
  CANVAS_OBJECT_TYPE_PREFIX.SHAPE_EDGE,
  CANVAS_OBJECT_TYPE_PREFIX.BUMP_OUT,
  CANVAS_OBJECT_TYPE_PREFIX.DIAGONAL,
  CANVAS_OBJECT_TYPE_PREFIX.RADIUS_OUT,
  CANVAS_OBJECT_TYPE_PREFIX.CORNER_RADIUS_ARC,
];

/**
 * Mutates canvas objects by modifying their appearance
 */
export const changeObjectStrokeColorsAndPrefixes = (
  canvas: fabric.Canvas,
  _strokeColors?: Record<string, string | undefined>
): typeof _strokeColors => {
  const isRemovingColors = _strokeColors === undefined;
  const strokeColors = _strokeColors || {};

  canvas.getObjects().forEach((object) => {
    if (
      object.name?.startsWith(CANVAS_OBJECT_TYPE_PREFIX.SHAPE_MAIN) &&
      object instanceof fabric.Group
    ) {
      object.getObjects().forEach((subObject) => {
        if (
          subObject.name &&
          borderPrefixes.some((prefix) => subObject.name?.startsWith(prefix))
        ) {
          if (isRemovingColors) {
            strokeColors[subObject.name] = subObject.stroke;
            subObject.set({
              stroke: stroke.normal,
              strokeWidth: 1,
            });
          } else if (strokeColors[subObject.name]) {
            subObject.set({
              stroke: strokeColors[subObject.name],
              strokeWidth: 2,
            });
          }
        }
      });
    }

    if (hidePrefixes.some((prefix) => object.name?.startsWith(prefix))) {
      const props = isRemovingColors
        ? { opacity: 0, selectable: false, evented: false }
        : { opacity: 1, selectable: true, evented: true };

      object.set(props);
    }
  });

  return isRemovingColors ? strokeColors : undefined;
};

export const changeAndRevertCanvasAppearance = (
  canvas: fabric.Canvas,
  callback: (modifiedCanvas: fabric.Canvas) => void
): void => {
  const originalBackgroundColor = canvas.backgroundColor;
  // BEGIN: change strokes and background (fn below mutates the canvas)
  const originalStrokeColors = changeObjectStrokeColorsAndPrefixes(canvas);

  canvas.setBackgroundColor(theme.light.palette.white, () =>
    canvas.renderAll()
  );
  canvas.renderAll();

  callback(canvas);

  // END: revert strokes and background
  changeObjectStrokeColorsAndPrefixes(canvas, originalStrokeColors);

  if (originalBackgroundColor) {
    canvas.setBackgroundColor(originalBackgroundColor, () =>
      canvas.renderAll()
    );
  }
  canvas.renderAll();
};
